import axios from 'axios'
import { getAPIUrl } from '../API'
import { v4 as uuid } from 'uuid'

export interface SearchComplexOwnersListRequest {
  complex: string
  region: string
  suburb: string
}

export interface ComplexOwnerResponse {
  uuid: string
  cmaid: number
  erfNo: string
  streetNo: string
  address: string
  street: string
  owner: string
  ownerIDNo: string
  erfExtent: number
  erfUsage: string
}

export const searchComplexOwnersList: (
  options: SearchComplexOwnersListRequest,
) => Promise<ComplexOwnerResponse[]> = async (options) => {
  const { data } = await axios.post(
    `${getAPIUrl()}/BridgingFinance/complexownerslist`,
    options,
    {
      headers: {
        Authorization: `Bearer ${await sessionStorage.getItem('jwt')}`,
      },
    },
  )
  return (data.data as ComplexOwnerResponse[]).map((item) => ({
    ...item,
    uuid: uuid(),
  }))
}
